<template>
  <div class="pai-skeleton-container">
    <div class="pai-skeleton-container-header">
      <Skeleton height="20px" width="150px" borderRadius="4px" />
    </div>
    <div class="pai-skeleton-container-main">
      <div class="pai-skeleton-container-main-middle">
        <div class="pai-skeleton-container-main-middle-left">
          <div class="pai-skeleton-container-main-middle-left-top">
            <Skeleton height="18px" width="278px" borderRadius="4px" />
            <Skeleton height="28px" width="469px" borderRadius="4px" />
          </div>
          <div class="pai-skeleton-container-main-middle-left-bottom">
            <div class="pai-skeleton-container-main-middle-left-bottom-left">
              <Skeleton height="20px" width="20px" borderRadius="4px" />
              <Skeleton height="16px" width="30px" borderRadius="4px" />
            </div>
            <div class="pai-skeleton-container-main-middle-left-bottom-right">
              <Skeleton height="20px" width="20px" borderRadius="4px" />
              <Skeleton height="16px" width="30px" borderRadius="4px" />
            </div>
          </div>
        </div>
        <div class="pai-skeleton-container-main-middle-right">
          <div class="pai-skeleton-container-main-middle-right-middle">
            <div class="pai-skeleton-container-main-middle-right-middle-top">
              <Skeleton height="18px" width="278px" borderRadius="4px" />
              <Skeleton height="28px" width="469px" borderRadius="4px" />
            </div>
            <div class="pai-skeleton-container-main-middle-right-middle-bottom">
              <div
                class="pai-skeleton-container-main-middle-right-middle-bottom-left"
              >
                <Skeleton height="20px" width="20px" borderRadius="4px" />
                <Skeleton height="16px" width="30px" borderRadius="4px" />
              </div>
              <div
                class="pai-skeleton-container-main-middle-right-middle-bottom-right"
              >
                <Skeleton height="20px" width="20px" borderRadius="4px" />
                <Skeleton height="16px" width="30px" borderRadius="4px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pai-skeleton-container-footer">
      <div class="pai-skeleton-container-footer-left">
        <Skeleton width="20px" height="20px" borderRadius="4px" />
        <Skeleton width="206px" height="16px" borderRadius="4px" />
      </div>
      <div class="pai-skeleton-container-footer-right">
        <Skeleton width="212px" height="40px" borderRadius="6px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.pai-skeleton-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;
  padding-bottom: 24px;

  &-header,
  &-footer {
    display: flex;
    align-items: center;
    gap: 16px;
    align-self: stretch;
  }

  &-main,
  &-main-middle-left,
  &-main-middle-left-top,
  &-main-middle-right-middle,
  &-main-middle-right-middle-top {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &-main-middle,
  &-main-middle-left-bottom,
  &-main-middle-right,
  &-main-middle-right-middle-bottom {
    display: flex;
    align-items: flex-start;
  }

  &-main-middle-left-bottom-left,
  &-main-middle-left-bottom-right,
  &-main-middle-right-middle-bottom-left,
  &-main-middle-right-middle-bottom-right,
  &-footer-left,
  &-footer-right {
    display: flex;
    align-items: center;
  }

  &-header {
    padding: 24px 24px 16px 24px;
    gap: 16px;
    border-bottom: 0.5px solid $colorD20;
  }

  &-main {
    padding: 16px 24px 24px 24px;
    gap: 16px;
    align-self: stretch;

    &-middle {
      align-self: stretch;

      &-left {
        padding-right: 24px;
        gap: 12px;
        flex: 1 0 0;
        align-self: stretch;
        border-right: 0.5px solid $colorD20;

        &-top {
          gap: 6px;
          align-self: stretch;
        }

        &-bottom {
          gap: 24px;

          &-left,
          &-right {
            gap: 8px;
          }
        }
      }

      &-right {
        padding-left: 24px;
        gap: 16px;
        flex: 1 0 0;
        align-self: stretch;

        &-middle {
          justify-content: center;
          gap: 12px;
          flex: 1 0 0;

          &-top {
            gap: 6px;
            align-self: stretch;
          }

          &-bottom {
            gap: 24px;

            &-left,
            &-right {
              gap: 8px;
            }
          }
        }
      }
    }
  }

  &-footer {
    padding-right: 24px;
    justify-content: flex-end;

    &-left {
      gap: 8px;
    }

    &-right {
      justify-content: center;
      gap: 2px;
    }
  }
}
</style>
